import { authUrl } from '@/features/login-and-signup/services/config';
import {
  CancelTicketRequest,
  CancelTicketResponse,
  VerifyUserEmailRequest,
  VerifyUserEmailResponse,
} from '@/features/wallet/services/types';
import { createMutation } from '@/logic/libs';
import { ordersUrl } from '@/logic/services';

export const useCancelTicket = createMutation<CancelTicketResponse, CancelTicketRequest>({
  method: 'post',
  url: `${ordersUrl}/:orderId/cancel`,
});

export const useInitVerifyUserEmail = createMutation<unknown, unknown>({
  method: 'post',
  url: `${authUrl}/init-verify-email-user`,
});

export const useVerifyUserEmail = createMutation<
  VerifyUserEmailResponse,
  VerifyUserEmailRequest
>({
  method: 'post',
  url: `${authUrl}/verify-email-user`,
});
